import Vue from 'vue'

let bus = new Vue()
function pub(channel, data) {
    bus.$emit(channel, data)
}
function sub(channel, callback) {
    bus.$on(channel, callback)
}

export {
    pub,
    sub
}